/**
 * Shared vertical rhythm between page sections.
 * Total gap between sections = paddingY of A (bottom) + paddingY of B (top).
 */
const breakpoints = {
  desktop: "1024px",
  tablet: "768px",
  phone: "0px",
};

const sectionRhythm = {
  gap: { mobile: 80, desktop: 120 },
  paddingY: { mobile: 40, desktop: 60 },
  /** Fixed header height -> matches Header + Layout offset. Used to even out the bottom gaps on pages */
  headerHeight: { mobile: 60, desktop: 80 },
  breakpoint: breakpoints.tablet,
};

module.exports = { sectionRhythm, breakpoints };
